import { Divider, Stack } from "@mui/material";
import CustomProgressBar from "components/CustomProgressBar";
import CustomText from "components/typography/CustomText";
import React from "react";

export default function DailySummaryInfo({ summary = [] }) {
  const deliveredCount = summary?.filter((item) =>
    Boolean(item?.tracking_info?.consignmentId)
  )?.length;
  return (
    <div>
      <Stack
        className="h-full w-full"
        justifyContent="space-between"
        direction="row"
        divider={
          <Divider
            className="border-r border-white-gray"
            orientation="vertical"
            flexItem
          />
        }
      >
        <div className="w-1/6 px-4">
          <CustomText variant="body2">Number of boxes:</CustomText>
          <CustomText variant="h6" bold={600}>
            {summary?.length}
          </CustomText>
        </div>
        <div className="w-1/6 px-4">
          <CustomText variant="body2">Number of pies:</CustomText>
          <CustomText variant="h6" bold={600}>
            {summary?.length * 8}
          </CustomText>
        </div>
        <div className="w-4/6 px-4 flex items-center">
          <CustomText>Percentage:</CustomText>
          <div className="flex-1 mx-2">
            <CustomProgressBar
              variant="determinate"
              value={
                100 *
                (summary?.length === 0
                  ? 0
                  : deliveredCount / Number(summary?.length))
              }
            />
          </div>
          <CustomText>
            {100 *
              (summary?.length === 0
                ? 0
                : deliveredCount / Number(summary?.length)
              ).toFixed(2)}
            %
          </CustomText>
        </div>
      </Stack>
    </div>
  );
}
